// before 20-5-2026

// import { Box, CircularProgress, useTheme } from '@mui/material';
// import React, { useEffect, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { Link, useNavigate } from 'react-router-dom';
// import AccessibilityNewIcon from '@mui/icons-material/AccessibilityNew';
// import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
// import BookmarkIcon from '@mui/icons-material/Bookmark';
// import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
// import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
// import TaskAltIcon from '@mui/icons-material/TaskAlt';
// import PhonelinkEraseIcon from '@mui/icons-material/PhonelinkErase';
// import ThumbUpIcon from '@mui/icons-material/ThumbUp';
// import CancelIcon from '@mui/icons-material/Cancel';
// import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
// import BackspaceIcon from '@mui/icons-material/Backspace';
// import { GetallStagesWithLeadsCount_For_Marketer_CRM_DATA_Dashboard_Action } from '../../Redux/Actions/UsersAction';

// export const QuickNumbersForMarketerCRMDATA = ({ darkMode = false }) => {
//   const theme = useTheme();
//   const mode = theme.palette.mode;
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const [userlogin, setUserLogin] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [stageLeadscountarray, setStageLeadscountarray] = useState([]);
//   const [totalCustomers, setTotalCustomers] = useState(0);

//   const stagesIcons = {
//     Fresh: <TipsAndUpdatesIcon />,
//     'Follow Up': <BookmarkIcon />,
//     Interested: <ThumbUpIcon />,
//     'Not Interested': <BackspaceIcon />,
//     Meeting: <AccessTimeFilledIcon />,
//     'Follow After Meeting': <WorkHistoryIcon />,
//     'Done Deal': <TaskAltIcon />,
//     'No Answer': <PhonelinkEraseIcon />,
//     'No Answer 1st Call': <AccessAlarmIcon />,
//     Cancellation: <CancelIcon />,
//     Transfer: <AccessAlarmIcon />,
//   };

//   useEffect(() => {
//     const user = localStorage.getItem('user');
//     if (user) {
//       setUserLogin(JSON.parse(user));
//     }
//   }, []);

//   const resAllStagesWithleadscount = useSelector(
//     (state) => state.Allusers.Stages_With_LeadsCount_Marketer_CRM_DATA,
//   );

//   useEffect(() => {
//     const fetchData = async () => {
//       if (!userlogin?.data?._id) return;
//       setLoading(true);
//       await dispatch(
//         GetallStagesWithLeadsCount_For_Marketer_CRM_DATA_Dashboard_Action(userlogin?.data?._id),
//       );
//     };
//     fetchData();
//   }, [dispatch, userlogin]);

//   useEffect(() => {
//     if (resAllStagesWithleadscount?.data) {
//       setStageLeadscountarray(resAllStagesWithleadscount?.data);
//       setTotalCustomers(resAllStagesWithleadscount.totalLeads || 0);
//       setLoading(false);

//       // ✅ إضافة console.log للتحقق من البيانات
//       console.log('🎯 Stages data:', resAllStagesWithleadscount.data);
//       console.log('🎯 Total leads:', resAllStagesWithleadscount.totalLeads);
//     }
//   }, [resAllStagesWithleadscount]);

//   const refreshLeads = () => {
//     localStorage.removeItem('stagestorage');
//     navigate('/ALLLeadsForMarketerCRMDATA');
//   };

//   // ✅ إصلاح دالة handleStageClick لاستخدام stageId بدلاً من stageName
//   const handleStageClick = (stageId) => {
//     console.log('🎯 Stage clicked:', stageId);

//     // تحديث localStorage للـ stage
//     localStorage.setItem('stagestorage', stageId);

//     // التنقل مع query parameter
//     navigate(`/ALLLeadsForMarketerCRMDATA?stage=${encodeURIComponent(stageId)}`);

//     // إضافة تأخير صغير ثم إرسال event لتحديث الصفحة
//     setTimeout(() => {
//       window.dispatchEvent(new Event('stageFilterUpdated'));
//     }, 100);
//   };

//   const handleGoToDuplicates = () => {
//     navigate('/ALLLeadsForMarketerCRMDATA?duplicates=true&ignoreduplicate=true');
//   };

//   if (loading && stageLeadscountarray.length === 0) {
//     return (
//       <Box display="flex" justifyContent="center" alignItems="center" height="300px">
//         <CircularProgress style={{ color: '#0F7687' }} />
//       </Box>
//     );
//   }

//   return (
//     <div
//       style={{
//         width: '100%',
//         padding: '20px 74px',
//         backgroundColor: mode === 'dark' ? '#1a1a1a' : '#f5f5f5',
//         minHeight: '100vh',
//       }}
//       className="fade-in startpage"
//     >
//       {/* العنوان الرئيسي */}
//       <div
//         style={{
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center',
//           marginBottom: '24px',
//           padding: '0 8px',
//         }}
//       >
//         <div
//           className={`section-title ${mode === 'dark' ? 'dark' : ''}`} /* ✅ تم تعديل darkMode إلى mode */
//           style={{ color: mode === 'dark' ? '#90caf9' : '#102dff' }}
//         >
//           Quick Numbers For Data Center Dashboard
//         </div>

//         {/* زر Leads Center */}
//         <Link to="/dashboard" style={{ textDecoration: 'none' }}>
//           <button
//             style={{
//               padding: '8px 16px',
//               backgroundColor: mode === 'dark' ? '#1976d2' : '#102dff',
//               color: 'white',
//               border: 'none',
//               borderRadius: '4px',
//               cursor: 'pointer',
//               fontSize: '14px',
//               fontWeight: '500',
//               transition: 'all 0.3s ease',
//               boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
//             }}
//             onMouseEnter={(e) => {
//               e.target.style.backgroundColor = mode === 'dark' ? '#1565c0' : '#0a1eb8';
//               e.target.style.transform = 'scale(1.05)';
//             }}
//             onMouseLeave={(e) => {
//               e.target.style.backgroundColor = mode === 'dark' ? '#1976d2' : '#102dff';
//               e.target.style.transform = 'scale(1)';
//             }}
//           >
//             CRM Leads Center
//           </button>
//         </Link>
//       </div>

//       <div className="simple-cards-container" style={{ padding: '0 10px' }}>
//         {' '}
//         {/* ✅ padding للحاوية */}
//         {/* All Leads */}
//         <div
//           style={{
//             background: mode === 'dark' ? '#0F7687' : '#fff',
//             color: mode === 'dark' ? '#fff' : '#333',
//           }}
//           className={`simple-card ${mode === 'dark' ? 'dark' : ''}`} /* ✅ تم تعديل darkMode إلى mode */
//           onClick={refreshLeads}
//         >
//           <div className="card-content">
//             <h3
//               className={mode === 'dark' ? 'dark' : ''}
//               style={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: '8px',
//                 color: mode === 'dark' ? '#fff' : '#333',
//               }}
//             >
//               <AccessibilityNewIcon />
//               <span style={{ color: mode === 'dark' ? '#fff' : '#333' }}>All Leads</span>
//             </h3>
//             <p
//               style={{ color: mode === 'dark' ? '#fff' : '#333' }}
//               className={mode === 'dark' ? 'dark' : ''}
//             >
//               Total system leads
//             </p>
//             <div className="card-stats">
//               <span
//                 style={{ color: mode === 'dark' ? '#fff' : '#333' }}
//                 className={`count ${mode === 'dark' ? 'dark' : ''}`}
//               >
//                 {totalCustomers}
//               </span>
//               <span className={`percentage ${mode === 'dark' ? 'dark' : ''} mx-2`}>100%</span>
//             </div>
//           </div>
//         </div>
//         {/* Duplicate Card (second position) */}
//         {stageLeadscountarray
//           .filter((stage) => stage.stageName === 'Duplicate')
//           .map(({ stageId, stageName, leadCount, percentage }) => {
//             const icon = stagesIcons[stageName] || <BookmarkIcon />;
//             return (
//               <div
//                 key={stageId}
//                 className={`simple-card ${mode === 'dark' ? 'dark' : ''}`} /* ✅ تم تعديل darkMode إلى mode */
//                 onClick={handleGoToDuplicates}
//                 style={{
//                   background: mode === 'dark' ? '#0F7687' : '#fff',
//                   color: mode === 'dark' ? '#fff' : '#333',
//                 }}
//               >
//                 <div className="card-content">
//                   <h3
//                     className={mode === 'dark' ? 'dark' : ''}
//                     style={{
//                       display: 'flex',
//                       alignItems: 'center',
//                       gap: '8px',
//                       color: mode === 'dark' ? '#fff' : '#333',
//                     }}
//                   >
//                     {icon}
//                     {stageName}
//                   </h3>
//                   <p
//                     style={{ color: mode === 'dark' ? '#fff' : '#333' }}
//                     className={mode === 'dark' ? 'dark' : ''}
//                   >
//                     Leads with multiple versions
//                   </p>
//                   <div className="card-stats">
//                     <span
//                       style={{ color: mode === 'dark' ? '#fff' : '#333' }}
//                       className={`count ${mode === 'dark' ? 'dark' : ''}`}
//                     >
//                       {leadCount}
//                     </span>
//                     <span className={`percentage ${mode === 'dark' ? 'dark' : ''} mx-2`}>
//                       {percentage}
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             );
//           })}
//         {/* Other Stages */}
//         {stageLeadscountarray
//           .filter((stage) => stage.stageName !== 'Duplicate')
//           .map(({ stageId, stageName, leadCount, percentage }) => {
//             const icon = stagesIcons[stageName] || <BookmarkIcon />;
//             return (
//               <div
//                 key={stageId}
//                 className={`simple-card ${mode === 'dark' ? 'dark' : ''}`} /* ✅ تم تعديل darkMode إلى mode */
//                 onClick={() => handleStageClick(stageId)} // ✅ استخدام stageId
//                 style={{
//                   background: mode === 'dark' ? '#0F7687' : '#fff',
//                   color: mode === 'dark' ? '#fff' : '#333',
//                 }}
//               >
//                 <div className="card-content">
//                   <h3
//                     className={mode === 'dark' ? 'dark' : ''}
//                     style={{
//                       display: 'flex',
//                       alignItems: 'center',
//                       gap: '8px',
//                       color: mode === 'dark' ? '#fff' : '#333',
//                     }}
//                   >
//                     {icon}
//                     {stageName}
//                   </h3>
//                   <p
//                     style={{ color: mode === 'dark' ? '#fff' : '#333' }}
//                     className={mode === 'dark' ? 'dark' : ''}
//                   >
//                     Leads Of All System
//                   </p>
//                   <div className="card-stats">
//                     <span
//                       style={{ color: mode === 'dark' ? '#fff' : '#333' }}
//                       className={`count ${mode === 'dark' ? 'dark' : ''}`}
//                     >
//                       {leadCount}
//                     </span>
//                     <span className={`percentage ${mode === 'dark' ? 'dark' : ''} mx-2`}>
//                       {percentage}
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             );
//           })}
//       </div>
//     </div>
//   );
// };













// 20-5-2026

import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme, CircularProgress, Box } from '@mui/material';
import { GetallStagesWithLeadsCount_For_Marketer_CRM_DATA_Dashboard_Action } from '../../Redux/Actions/UsersAction';
import TrendingUpIcon                        from '@mui/icons-material/TrendingUp';
import TipsAndUpdatesIcon                    from '@mui/icons-material/TipsAndUpdates';
import BookmarkIcon                          from '@mui/icons-material/Bookmark';
import AccessTimeFilledIcon                  from '@mui/icons-material/AccessTimeFilled';
import AccessAlarmIcon                       from '@mui/icons-material/AccessAlarm';
import TaskAltIcon                           from '@mui/icons-material/TaskAlt';
import PhonelinkEraseIcon                    from '@mui/icons-material/PhonelinkErase';
import ThumbUpIcon                           from '@mui/icons-material/ThumbUp';
import CancelIcon                            from '@mui/icons-material/Cancel';
import WorkHistoryIcon                       from '@mui/icons-material/WorkHistory';
import BackspaceIcon                         from '@mui/icons-material/Backspace';
import AccessibilityNewIcon                  from '@mui/icons-material/AccessibilityNew';
import ControlPointDuplicateOutlinedIcon     from '@mui/icons-material/ControlPointDuplicateOutlined';
import HourglassEmptyOutlinedIcon            from '@mui/icons-material/HourglassEmptyOutlined';
import DoNotDisturbOnOutlinedIcon            from '@mui/icons-material/DoNotDisturbOnOutlined';
import ArrowCircleLeftOutlinedIcon           from '@mui/icons-material/ArrowCircleLeftOutlined';
import EventRepeatOutlinedIcon               from '@mui/icons-material/EventRepeatOutlined';
import PersonAddAltOutlinedIcon              from '@mui/icons-material/PersonAddAltOutlined';
import KeyboardDoubleArrowRightIcon          from '@mui/icons-material/KeyboardDoubleArrowRight';
import { useSidebarWidth }                   from '../../Utility/useSidebarWidth';

/* ── icons map ───────────────────────────────────────────────────── */
const stagesIcons = {
  'Fresh'                : <TipsAndUpdatesIcon    style={{ fontSize: 18 }} />,
  'Follow Up'            : <HourglassEmptyOutlinedIcon style={{ fontSize: 18 }} />,
  'Follow'               : <PersonAddAltOutlinedIcon  style={{ fontSize: 18 }} />,
  'Long Follow'          : <EventRepeatOutlinedIcon   style={{ fontSize: 18 }} />,
  'Interested'           : <ThumbUpIcon           style={{ fontSize: 18 }} />,
  'Not Interested'       : <DoNotDisturbOnOutlinedIcon style={{ fontSize: 18 }} />,
  'Meeting'              : <AccessTimeFilledIcon  style={{ fontSize: 18 }} />,
  'Follow After Meeting' : <WorkHistoryIcon        style={{ fontSize: 18 }} />,
  'Done Deal'            : <TaskAltIcon            style={{ fontSize: 18 }} />,
  'No Answer'            : <PhonelinkEraseIcon     style={{ fontSize: 18 }} />,
  'No Answer 1st Call'   : <AccessAlarmIcon        style={{ fontSize: 18 }} />,
  'Cancellation'         : <CancelIcon             style={{ fontSize: 18 }} />,
  'Cancel Meeting'       : <CancelIcon             style={{ fontSize: 18 }} />,
  'Transfer'             : <ArrowCircleLeftOutlinedIcon style={{ fontSize: 18 }} />,
  'Duplicate'            : <ControlPointDuplicateOutlinedIcon style={{ fontSize: 18 }} />,
};

/* ── number colour per stage ─────────────────────────────────────── */
const numberColor = (stageName) => {
  if (!stageName) return null;
  const n = stageName.toLowerCase();
  if (n.includes('cancel'))         return '#C62828';
  if (n.includes('not interested')) return '#C62828';
  if (n.includes('cancellation'))   return '#C62828';
  if (n.includes('pending'))        return '#B8860B';
  if (n.includes('done deal'))      return '#1B5E20';
  if (n.includes('reservation'))    return '#1B5E20';
  if (n.includes('eoi'))            return '#0D47A1';
  return null;
};

/* ── badge style ─────────────────────────────────────────────────── */
const badgeStyle = (pct) => {
  if (pct > 0) return { bg: '#EBF2FF', color: '#1A3ECF' };
  return         { bg: '#F3F4F6',  color: '#6B7280' };
};

/* ══════════════════════════════════════════════════════════════════ */
export const QuickNumbersForMarketerCRMDATA = ({ darkMode = false }) => {
  const theme        = useTheme();
  const dark         = theme.palette.mode === 'dark';
  const dispatch     = useDispatch();
  const navigate     = useNavigate();
  const sidebarWidth = useSidebarWidth();

  const [userlogin,            setUserLogin]            = useState(null);
  const [loading,              setLoading]              = useState(true);
  const [stageLeadscountarray, setStageLeadscountarray] = useState([]);
  const [totalCustomers,       setTotalCustomers]       = useState(0);

  useEffect(() => {
    const user = localStorage.getItem('user');
    if (user) setUserLogin(JSON.parse(user));
  }, []);

  const resAllStagesWithleadscount = useSelector(
    (state) => state.Allusers.Stages_With_LeadsCount_Marketer_CRM_DATA,
  );

  useEffect(() => {
    const fetchData = async () => {
      if (!userlogin?.data?._id) return;
      setLoading(true);
      await dispatch(
        GetallStagesWithLeadsCount_For_Marketer_CRM_DATA_Dashboard_Action(userlogin?.data?._id),
      );
    };
    fetchData();
  }, [dispatch, userlogin]);

  useEffect(() => {
    if (resAllStagesWithleadscount?.data) {
      setStageLeadscountarray(resAllStagesWithleadscount.data);
      setTotalCustomers(resAllStagesWithleadscount.totalLeads || 0);
      setLoading(false);
    }
  }, [resAllStagesWithleadscount]);

  const refreshLeads = () => {
    localStorage.removeItem('stagestorage');
    navigate('/ALLLeadsForMarketerCRMDATA');
  };

  const handleStageClick = (stageId) => {
    localStorage.setItem('stagestorage', stageId);
    navigate(`/ALLLeadsForMarketerCRMDATA?stage=${encodeURIComponent(stageId)}`);
    setTimeout(() => { window.dispatchEvent(new Event('stageFilterUpdated')); }, 100);
  };

  const handleGoToDuplicates = () => {
    navigate('/ALLLeadsForMarketerCRMDATA?duplicates=true&ignoreduplicate=true');
  };

  /* ── حساب النسبة الحقيقية من total ── */
  const calcPct = (count) => {
    if (!totalCustomers || totalCustomers === 0) return 0;
    return Math.round((count / totalCustomers) * 100);
  };

  /* ── tokens ── */
  const cardBg  = dark ? '#1E1E2E' : '#FFFFFF';
  const border  = dark ? 'rgba(255,255,255,0.07)' : '#E8EAF0';
  const textPri = dark ? '#E2E8F0' : '#111827';
  const textSec = dark ? '#94A3B8' : '#9CA3AF';
  const accent  = '#1A3ECF';

  if (loading && stageLeadscountarray.length === 0) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height={300}>
        <CircularProgress style={{ color: accent }} />
      </Box>
    );
  }

  /* ── single card — نفس ديزاين QuickNumbers بالظبط ── */
  const Card = ({ stageName, leadCount, onClick, pct }) => {
    const bs     = badgeStyle(pct);
    const numCol = numberColor(stageName) || (dark ? '#E2E8F0' : '#111827');
    const icon   = stagesIcons[stageName] || <BookmarkIcon style={{ fontSize: 18 }} />;

    return (
      <div
        onClick={onClick}
        style={{
          background    : cardBg,
          border        : `1px solid ${border}`,
          borderRadius  : 16,
          padding       : '24px 22px 20px',
          cursor        : 'pointer',
          position      : 'relative',
          transition    : 'box-shadow 0.18s, transform 0.18s',
          display       : 'flex',
          flexDirection : 'column',
          justifyContent: 'space-between',
          minHeight     : 115,
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.boxShadow = '0 6px 24px rgba(0,0,0,0.08)';
          e.currentTarget.style.transform = 'translateY(-2px)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.boxShadow = 'none';
          e.currentTarget.style.transform = 'translateY(0)';
        }}
      >
        {/* badge بالنسبة الحقيقية */}
        <div style={{
          position    : 'absolute',
          top         : 16,
          right       : 16,
          display     : 'flex',
          alignItems  : 'center',
          gap         : 2,
          fontSize    : 11,
          fontWeight  : 600,
          color       : bs.color,
          background  : bs.bg,
          borderRadius: 20,
          padding     : '3px 8px',
          lineHeight  : 1,
        }}>
          {pct > 0 && <TrendingUpIcon style={{ fontSize: 12 }} />}
          {pct}%
        </div>

        {/* icon صغير فوق الرقم */}
        <div style={{ color: numberColor(stageName) || accent, opacity: 0.55, marginBottom: 6, lineHeight: 1 }}>
          {icon}
        </div>

        {/* big number */}
        <div style={{
          fontSize     : 42,
          fontWeight   : 800,
          color        : numCol,
          lineHeight   : 1,
          fontFamily   : "'DM Sans', sans-serif",
          letterSpacing: '-1.5px',
        }}>
          {typeof leadCount === 'number' ? leadCount.toLocaleString() : leadCount}
        </div>

        {/* stage label */}
        <div style={{
          fontSize     : 11,
          fontWeight   : 600,
          letterSpacing: '0.09em',
          color        : textSec,
          marginTop    : 16,
          textTransform: 'uppercase',
        }}>
          {stageName}
        </div>
      </div>
    );
  };

  /* ── render ── */
  return (
    <div style={{
      position  : 'fixed',
      top       : '50px',
      left      : sidebarWidth,
      right     : 0,
      bottom    : 0,
      overflowY : 'auto',
      overflowX : 'hidden',
      transition: 'left 0.25s cubic-bezier(0.4,0,0.2,1)',
      background: dark ? '#0f1117' : '#f4f6fb',
      padding   : '28px 28px 48px',
      fontFamily: "'DM Sans', sans-serif",
    }}>

      {/* breadcrumb */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, marginBottom: 20, flexWrap: 'wrap' }}>
        <span
          onClick={() => navigate('/dashboard')}
          style={{ color: accent, fontWeight: 600, cursor: 'pointer' }}
        >
          Dashboard
        </span>
        <KeyboardDoubleArrowRightIcon style={{ fontSize: 14, color: '#9ca3af' }} />
        <span
          onClick={() => navigate('/ALLLeadsForMarketerCRMDATA')}
          style={{ color: accent, fontWeight: 600, cursor: 'pointer' }}
        >
          CRM Data Leads
        </span>
        <KeyboardDoubleArrowRightIcon style={{ fontSize: 14, color: '#9ca3af' }} />
        <span style={{ color: '#9ca3af' }}>Quick Numbers</span>
      </div>

      {/* header */}
      <div style={{
        display       : 'flex',
        justifyContent: 'space-between',
        alignItems    : 'flex-start',
        marginBottom  : 22,
      }}>
        <div>
          <h2 style={{ margin: 0, fontSize: 20, fontWeight: 700, color: textPri }}>
            Quick Numbers — CRM Data Center
          </h2>
          <p style={{ margin: '4px 0 0', fontSize: 13, color: textSec }}>
            Real-time engagement metrics for your CRM data portfolio
          </p>
        </div>

        <button
          onClick={() => navigate('/ALLLeadsForMarketerCRMDATA')}
          style={{
            background    : 'none',
            border        : 'none',
            cursor        : 'pointer',
            color         : accent,
            fontSize      : 13,
            fontWeight    : 700,
            fontFamily    : "'DM Sans', sans-serif",
            textDecoration: 'none',
            padding       : 0,
          }}
          onMouseEnter={(e) => { e.currentTarget.style.textDecoration = 'underline'; }}
          onMouseLeave={(e) => { e.currentTarget.style.textDecoration = 'none'; }}
        >
          CRM Leads Center
        </button>
      </div>

      {/* loading */}
      {loading && stageLeadscountarray.length === 0 ? (
        <Box display="flex" justifyContent="center" alignItems="center" height={300}>
          <CircularProgress style={{ color: accent }} />
        </Box>
      ) : (
        <div style={{
          display            : 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
          gap                : 16,
        }}>
          {/* All Leads — 100% دايماً */}
          <Card
            stageName ="All Leads"
            leadCount ={totalCustomers}
            onClick   ={refreshLeads}
            pct       ={100}
          />

          {/* Duplicate */}
          {stageLeadscountarray
            .filter((s) => s.stageName === 'Duplicate')
            .map(({ stageId, stageName, leadCount }) => (
              <Card
                key      ="dup"
                stageName={stageName}
                leadCount={leadCount}
                onClick  ={handleGoToDuplicates}
                pct      ={calcPct(leadCount)}
              />
            ))}

          {/* Other stages */}
          {stageLeadscountarray
            .filter((s) => s.stageName !== 'Duplicate')
            .map(({ stageId, stageName, leadCount }) => (
              <Card
                key      ={stageId}
                stageName={stageName}
                leadCount={leadCount}
                onClick  ={() => handleStageClick(stageId)}
                pct      ={calcPct(leadCount)}
              />
            ))}
        </div>
      )}
    </div>
  );
};
